var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4194_44233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 3.49935V1.74935C4.08333 1.59464 4.14479 1.44627 4.25419 1.33687C4.36358 1.22747 4.51196 1.16602 4.66667 1.16602H11.6667C11.8214 1.16602 11.9697 1.22747 12.0791 1.33687C12.1885 1.44627 12.25 1.59464 12.25 1.74935V9.91602C12.25 10.0707 12.1885 10.2191 12.0791 10.3285C11.9697 10.4379 11.8214 10.4993 11.6667 10.4993H9.91667V12.2493C9.91667 12.5713 9.65417 12.8327 9.32925 12.8327H2.33742C2.26049 12.8331 2.18423 12.8184 2.11302 12.7893C2.04181 12.7602 1.97705 12.7173 1.92247 12.6631C1.86788 12.6089 1.82455 12.5444 1.79495 12.4734C1.76535 12.4024 1.75008 12.3263 1.75 12.2493L1.75175 4.08268C1.75175 3.76068 2.01425 3.49935 2.33917 3.49935H4.08333ZM5.25 3.49935H9.91667V9.33268H11.0833V2.33268H5.25V3.49935Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4194_44233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.f77e695fa871a276877ae5bd36c55877.svg";
export { ForwardRef as ReactComponent };